import { createIcon } from './create-icon'

export const Heart = createIcon({
  displayName: 'Heart',
  paths: [
    'M640 170.667c-48.256 0-92.245 16.64-128 43.605-35.755-26.965-79.744-43.605-128-43.605-117.803 0-213.333 95.488-213.333 213.333 0 48.256 16.64 92.245 43.605 128l265.643 304.64c8.491 9.685 20.267 14.549 32.085 14.549s23.595-4.864 32.085-14.549l265.643-304.64c26.965-35.755 43.605-79.744 43.605-128 0-117.845-95.531-213.333-213.333-213.333zM640 256c70.571 0 128 57.429 128 128 0 32.939-13.141 58.368-24.832 74.453l-231.168 265.173-231.168-265.173c-11.691-16.085-24.832-41.515-24.832-74.453 0-70.571 57.429-128 128-128 34.432 0 60.629 14.336 76.544 26.368l51.456 38.869 51.456-38.869c15.915-12.032 42.112-26.368 76.544-26.368z'
  ]
})
